import { WishListTable } from "../../ui/wish-list-table.tsx";

export const Wishlist = () => {


    return <section className="section">
        <div className="inside-wrapper">
            <h1 className="section__title">
                Your Video Stories Wishlist
            </h1>
            <WishListTable/>
        </div>
    </section>
}

export default Wishlist;